module.exports = __webpack_public_path__ + "static/media/quadrant-business-users-engineering-managers.fe3503d2.svg";